import { render, staticRenderFns } from "./header_component.vue?vue&type=template&id=6c4d6d4d"
import script from "./header_component.vue?vue&type=script&lang=js"
export * from "./header_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports